export default __webpack_public_path__ + "static/media/IPO_Central.e0bc1962.png";